import {
    useMemo,
} from 'react'

import SkyNetTable from 'app/shared-components/SkyNetTable'
import SkyNetDomain, {
    getUrlsFromTableConfig,
    SidebarTab,
} from 'app/shared-components/SkyNetDomain'
import {
    TableControlTypes,
} from 'app/shared-components/TableControls'
import useTabsByPermission from 'app/hooks/useTabsByPermission'
import {
    CommonRoutes,
} from 'app/enums/common.enums'

import {
    LocationsTabs,
} from 'app/enums/domain.enums'
import requests from 'app/requests/Location.requests'
import LocationOverview from '../Locations/LocationOverview'
import LocationAreas from '../Locations/LocationAreas'

import getTableConfig from './AirportsAndSeaports.config'

const tableControls: TableControlTypes[] = [
    TableControlTypes.ShowArhived,
    TableControlTypes.ClearFilters,
    TableControlTypes.ClearSorting,
]

export default function AirportsAndSeaports() {
    const tabs: SidebarTab[] = useTabsByPermission([
        {
            tab: {
                label: 'Overview',
                url: CommonRoutes.Overview,
                Component: LocationOverview,
            },
            permission: true,
        },
        {
            tab: {
                label: 'Areas',
                url: LocationsTabs.Areas,
                Component: LocationAreas,
            },
            permission: true,
        },

    ])

    const tableConfig = useMemo(() => {
        return getTableConfig()
    }, [])

    return (
        <SkyNetDomain
            name={tableConfig.name}
            defaultTab="overview"
            sidebarTabs={tabs}
            subdomainUrls={getUrlsFromTableConfig(tableConfig)}
        >
            <SkyNetTable
                moduleName={requests.domainName}
                tableControls={tableControls}
                tableConfig={tableConfig}
                showSearch
            />
        </SkyNetDomain>
    )
}
